import { storeEvent } from "_analytics/index";

import Presentation from "./presentation";

const component = ( { currentIndex, lastIndex, session, direction, disableFollowModal = false, isHorizontal, customClass } ) => {
	const handleGAEvent = ( { isLive, game = {}, type } ) => {
		switch ( type ) {
			case "media": {
				if ( isLive ) {
					storeEvent ( "Broadcast", "Viewed", `Game_Card_${ game?.name }` );

					return;
				}
				storeEvent ( "Video", "Play", `Game_Card_${ game?.name }` );

				return;
			}

			case "profile": {
				storeEvent ( "Profile_Viewed", "Game_Card_Content", `Game_Card_${ game?.name }` );

				return;
			}

			default:
				break;

		}
	};

	return (
		<Presentation
			currentIndex       = { currentIndex }
			customClass        = { customClass }
			direction          = { direction }
			disableFollowModal = { disableFollowModal }
			handleGAEvent      = { handleGAEvent }
			isHorizontal       = { isHorizontal }
			lastIndex          = { lastIndex }
			session            = { session }
		/>
	);
};

export default component;
